"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Audit/useAuditExport.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _format = require('./format');

// The server's refusals, shown as it words them; anything else is a failure.
const REFUSALS = [
  'Pick 12 months or less.',
  'Too many events for one file. Pick a shorter range or add a filter.',
]
 const EXPORT_FAILED = 'Failed to export the audit log. Try again.'; exports.EXPORT_FAILED = EXPORT_FAILED







const failureMessage = (e) => {
  // SAFETY: a rejected command carries the server's public error as Error, when it has one.
  const message = _optionalChain([(e ), 'optionalAccess', _ => _.Error])
  return typeof message === 'string' && REFUSALS.includes(message) ? message : exports.EXPORT_FAILED
}

/* Download CSV: builds the file on the server (ExportAuditLog), then a toast
 * names it and offers Download. onDone runs after a file is ready, as the
 * export is itself the log's newest event. */
 const useAuditExport = (onDone) => {
  const [state, setState] = _react.useState({ status: 'idle' })
  const onDoneRef = _react.useRef.call(void 0, onDone)
  onDoneRef.current = onDone
  const isMounted = _react.useRef.call(void 0, true)
  _react.useEffect.call(void 0, () => () => { isMounted.current = false }, [])

  const start = _react.useCallback.call(void 0, (filters) => {
    setState({ status: 'preparing' })
    _actions2.default.exportAuditLog(filters)
      .then(file => {
        if (!isMounted.current) return
        setState({ status: 'ready', file })
        _optionalChain([onDoneRef, 'access', _2 => _2.current, 'optionalCall', _3 => _3()])
      })
      .catch(e => { if (isMounted.current) setState({ status: 'failed', message: failureMessage(e) }) })
  }, [])
  const dismiss = _react.useCallback.call(void 0, () => setState({ status: 'idle' }), [])

  return { state, isPreparing: state.status === 'preparing', start, dismiss }
}; exports.useAuditExport = useAuditExport



// The toast at the bottom of the window: the file and Download, or why not.
 const AuditExportToast = ({ state, dismiss }) => (
  _react2.default.createElement('div', { className: "audit-toast--anchor", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
    ,  state.status === 'ready' && (
      _react2.default.createElement('div', { className: "audit-toast", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
        , _react2.default.createElement('span', { className: "audit-toast--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
          ,  state.file.FileName , " is ready ("   ,  _format.formatCount.call(void 0, state.file.Rows) , " " ,  state.file.Rows === 1 ? 'event' : 'events' , ")"
        )
        , _react2.default.createElement('a', { className: "audit-toast--action", href: state.file.URL, download: state.file.FileName, onClick: dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Download")
        , _react2.default.createElement('button', { type: "button", className: "audit-toast--close", 'aria-label': "Dismiss", onClick: dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "×")
      )
    )
    ,  state.status === 'failed' && (
      _react2.default.createElement('div', { className: "audit-toast audit-toast--error" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
        , _react2.default.createElement('span', { className: "audit-toast--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}},  state.message )
        , _react2.default.createElement('button', { type: "button", className: "audit-toast--close", 'aria-label': "Dismiss", onClick: dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "×")
      )
    )
  )
); exports.AuditExportToast = AuditExportToast
